import { STATE } from '@origin-digital/sales-common';

export const DEFAULT_POSTCODE = '2000';
export const DEFAULT_STATE: STATE = 'NSW';
